import './chunk-1fafdf15.js';
import './helpers.js';
import './chunk-6985c8ce.js';
import './chunk-d0a313ea.js';
import './chunk-cdfca85b.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-d1591eb8.js';
import './chunk-1196ee55.js';
import './chunk-42f463e6.js';
import './chunk-4d76806f.js';
import './chunk-eb60b35a.js';
import './chunk-77ffdf8b.js';
import { T as Timepicker } from './chunk-a684d1f3.js';
export { T as BTimepicker } from './chunk-a684d1f3.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Timepicker);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/timepicker.js
// module id = 81
// module chunks = 10